export default "__VITE_ASSET__CJ7zpem5__"